import { render, staticRenderFns } from "./pbl3.vue?vue&type=template&id=79ee29a0&scoped=true&"
import script from "./pbl3.vue?vue&type=script&lang=js&"
export * from "./pbl3.vue?vue&type=script&lang=js&"
import style0 from "./pbl3.vue?vue&type=style&index=0&id=79ee29a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ee29a0",
  null
  
)

export default component.exports